export const DISPLAY = {
  degrees: "Degrees",
  year: "Year",
  day: "Day",
  planets: "Planets",
};

export const OVERLAY = {
  degrees: "Degrees",
};

export const DIRECTION_NAMES = {
  0: "East",
  90: "North",
  180: "West",
  270: "South",
};

export const DIRECTION = {
  clockwise: "Clockwise",
  counter_clockwise: "Counter Clockwise",
};

export const START_FROM = {
  east: "East",
  west: "West",
  north: "North",
  south: "South",
  moveable: "Moveable",
  selection: "Selection",
};

export const OVERLAY_START_FROM = {
  selection: "Selection",
  fixed: "Fixed",
};

export const PLANET_NAMES = {
  sun: "Sun",
  moon: "Moon",
  mars: "Mars",
  mercury: "Mercury",
  venus: "Venus",
  jupiter: "Jupiter",
  saturn: "Saturn",
  uranus: "Uranus",
  neptune: "Neptune",
  pluto: "Pluto",
  trueNode: "True Node",
};

export const ADMIN_ROLE_ID = "676e8f02c13068ac208562a8"